export enum EState {
    DEFAULT = "default",
    HOVER = "hover",
}
